export class PasswordChangeEventRequest {
}
export var PasswordChangeReason;
(function (PasswordChangeReason) {
    PasswordChangeReason[PasswordChangeReason["user_update"] = 0] = "user_update";
    PasswordChangeReason[PasswordChangeReason["forgot_password"] = 1] = "forgot_password";
    PasswordChangeReason[PasswordChangeReason["forced_reset"] = 2] = "forced_reset";
})(PasswordChangeReason || (PasswordChangeReason = {}));
export var PasswordChangeStatus;
(function (PasswordChangeStatus) {
    PasswordChangeStatus[PasswordChangeStatus["pending"] = 0] = "pending";
    PasswordChangeStatus[PasswordChangeStatus["success"] = 1] = "success";
    PasswordChangeStatus[PasswordChangeStatus["failure"] = 2] = "failure";
})(PasswordChangeStatus || (PasswordChangeStatus = {}));
